export default "__VITE_ASSET__08689fa5__"